import React from "react";
import {Button, Tooltip} from "@mui/material";
import {useTheme} from "../../../../contexts/theme";

export const commonButtonStyles = (theme, { selected = false, login = false, color = 'white', needBackgroundColor = false } = {}
) => ({
    color: color,
    backgroundColor: !selected ? (! needBackgroundColor ?  'transparent': theme.palette.blue) : theme.palette.orange,
    border: `${theme.border.type.solid} ${theme.border.width.medium} ${
        !selected ? (login ? theme.palette.black : theme.palette.lightGrey) : theme.palette.orange
    }`,
    borderRadius: theme.border.radius.md,
    transition: 'background-color 0.5s',
    padding: theme.spacing.sm,
    textTransform: 'none',
    '&:hover': {
        backgroundColor: theme.palette.orange,
        borderColor: theme.palette.orange,
        border: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}`,
    },
    '&:disabled': {
        borderColor: theme.palette.lightGrey,
        color: theme.palette.lightGrey,
        border: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.lightGrey}`,
    },
    '& .MuiButton-startIcon': {
        marginLeft: 0,
        marginRight: 0,
    },
});

const TransparentButton = ({needBackground, login = false, type, startIcon, height, icon, color = 'white', marginLeft, onBlur, width, text, disabled, onClick, onFocus, selected, marginRight, tooltipText, showTooltip}) => {

    const theme = useTheme();

    const buttonElement = (
        <Button onBlur={onBlur} type={type} onFocus={onFocus} variant='outlined' disabled={disabled} onClick={onClick} startIcon={startIcon}
                sx={{
                    marginLeft: marginLeft || undefined,
                    marginRight: marginRight || undefined,
                    height: height || "40px",
                    width: width || 'auto',
                    ...commonButtonStyles(theme, { selected, login, color, needBackgroundColor: needBackground }),
                }}
        >
            {text}
        </Button>
    )

    return (
        showTooltip ? (
            <Tooltip title={tooltipText}>
                <span>{buttonElement}</span>
            </Tooltip>
        ) : (
            buttonElement
        )
    );
};

export default TransparentButton;